import MuvalLogo from 'app/assets/icons/muval.png'
import { Box } from 'app/components/design-system-components'
import MuvalLink from 'app/Integrations/components/Muval/MuvalLink'

const defaultText = (
  <>
    Get quotes from verified local removalists.{' '}
    <MuvalLink textInLink="learn more" />
  </>
)

function MuvalLogoAndDesc({ text = defaultText }) {
  return (
    <Box lineHeight="140%">
      <img src={MuvalLogo} alt="Muval" style={{ maxWidth: '165px' }} />
      <Box mt={5}>{text}</Box>
    </Box>
  )
}

export default MuvalLogoAndDesc
